// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"0b5e95bf","166":"f7bc5b5d","453":"2bda2190","485":"a8cf4402","563":"bbbd4a17","907":"130b8976","944":"2c19a72b"}[chunkId] + ".chunk.js";
};